module.exports = __webpack_public_path__ + "static/media/bg_rectangle-dark-1.4cbe8d87.jpg";